import { render } from "./OrderOriginalCode.vue?vue&type=template&id=0f06ee18&scoped=true"
import script from "./OrderOriginalCode.vue?vue&type=script&lang=js"
export * from "./OrderOriginalCode.vue?vue&type=script&lang=js"

import "./OrderOriginalCode.vue?vue&type=style&index=0&id=0f06ee18&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f06ee18"]])

export default __exports__